export class Merchant {
  constructor({ id, name, phone = '', notes = '', createdAt }) {
    this.id = id;
    this.name = name;
    this.phone = phone;
    this.notes = notes;
    this.createdAt = createdAt;
  }

  toJson() {
    return {
      name: this.name,
      phone: this.phone || '',
      notes: this.notes || '',
      createdAt: this.createdAt,
    };
  }

  static fromFirebase(doc) {
    const data = doc.data();
    return new Merchant({
      id: doc.id,
      name: data.name,
      phone: data.phone || '',
      notes: data.notes || '',
      createdAt: data.createdAt,
    });
  }
}
